import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=6b4f5c52"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=6b4f5c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports